import React from 'react';
import BottomNavbar from '../userNavbar/BottomNavbar';
import TopNavbar from '../userNavbar/TopNavabar';

const UserNavbar = () => {
    return (
        <div className="sticky top-0 w-full z-50">
            <TopNavbar/>
            <BottomNavbar />
        </div>
    );
};

export default UserNavbar;